<template>

    <div class="new-email-modal-form">
        <h3 v-if="showRequestSelect && emailType === 'provider' && providerSelected">EMAIL {{ providerSelected.provider.name }}</h3>
        <template v-if="showRequestSelect && emailType === 'provider' && providerSelected && providerSelected.requests ">
            <requests-select
                v-bind:requests="providerSelected.requests"
                v-bind:options="requestOptions"
            ></requests-select>
        </template>
        <div class="buttons-wrapper is-flex is-justify-content-right">
            <div class="is-flex">
                <button
                    class="button is-large"
                    v-on:click.prevent.stop="saveDraft"
                    v-bind:class="{ 'is-loading' : isLoading.draft }"
                    style="margin: 10px"
                >Outlook Entwurf erstellen</button>
                <div>
                    <button
                        class="button is-primary is-large mr-0"
                        v-bind:class="{ 'is-loading' : isLoading.send }"
                        v-on:click="send('close')"
                        style="margin: 10px"
                    ><i class="material-icons">check</i> Email senden</button>

                    <!--                <button
                                        class="button is-primary is-large"
                                        v-bind:class="{ 'is-loading' : isLoading.send }"
                                        v-on:click="send('close')"
                                    ><i class="material-icons">keyboard_arrow_right</i>Senden und Schließen</button>-->
                </div>

            </div>
        </div>
        <div class="input-wrapper">
            <label>Von:</label>
            <email-select v-model="newEmail.fromEmail" @input="$store.dispatch('fillEmailBody')"/>
        </div>

        <div class="input-wrapper">
            <label>An:</label>
            <multiselect
                :toBeCopied="true"

                v-model         = "newEmail.toAddresses"
                v-bind:options  = "toContacts"
                v-bind:multiple = "true"
                v-bind:taggable = "true"
                v-bind:loading  = "isLoading.toContacts"
                v-bind:internal-search = "false"
                label           = "email"
                track-by        = "email"
                placeholder     = ""
                v-on:tag        = "item => addContact(item, 'to')"
                v-on:open          = "getContacts('', 'to')"
                v-on:search-change = "search => getContacts(search, 'to')"
                v-on:close         = "tryContactPreselect('to')"
            >
                <template slot="option" slot-scope="props" v-if="props.option.firstName || props.option.email || props.option.lastName" >
                        <span class="option__name" v-if="props.option.firstName"><i class="material-icons">perm_identity</i> {{ props.option.firstName + ' ' + props.option.lastName   + " - " +  props.option.email }}</span>
                        <span class="option__name" v-else><i class="material-icons">perm_identity</i> {{ props.option.email }}</span>

                        <span class="option__type">
                        <template v-if="props.client"><i class="material-icons">business</i> Company: {{ props.option.client.companyName }}</template>
                        </span>

                </template>

                <span slot="caret" v-if="toContacts.length === 0"></span>
            </multiselect>
        </div>

        <div class="recent-contact-hint" v-if="showRecentContact">
            <i class="material-icons">history</i>
            <span>
                Zuletzt geschrieben:
                <strong>{{ recentContact.name || recentContact.email }}</strong>
                <template v-if="recentContact.name">({{ recentContact.email }}<template v-if="recentContact.date">, {{ recentContact.date.substr(0, 10) }}</template>)</template>
                <template v-else-if="recentContact.date">({{ recentContact.date.substr(0, 10) }})</template>
                <span class="tag is-new" v-if="!recentContact.knownContact" title="Noch kein Kontakt beim Leistungsträger — wird beim Übernehmen angelegt">neu</span>
            </span>
            <button
                type="button"
                class="button is-small"
                v-bind:class="{ 'is-loading': isLoading.recentContact }"
                v-on:click="takeRecentContact"
            >{{ recentContact.knownContact ? 'Als Empfänger' : 'Anlegen & als Empfänger' }}</button>
        </div>

        <div class="input-wrapper">
            <label>CC:</label>
            <multiselect
                :toBeCopied="true"

                v-model         = "newEmail.ccAddresses"
                v-bind:options  = "ccContacts"
                v-bind:multiple = "true"
                v-bind:taggable = "true"
                v-bind:loading  = "isLoading.ccContacts"
                v-bind:internal-search = "false"
                label           = "email"
                track-by        = "email"
                placeholder     = ""
                v-on:tag        = "item => addContact(item, 'cc')"
                v-on:open          = "getContacts('', 'cc')"
                v-on:search-change = "search => getContacts(search, 'cc')"
                v-on:close         = "tryContactPreselect('cc')"
            >
                <template slot="option" slot-scope="props" v-if="props.option.firstName || props.option.email || props.option.lastName" >
                    <span class="option__name" v-if="props.option.firstName" ><i class="material-icons">perm_identity</i> {{ props.option.firstName + ' ' + props.option.lastName + " - " + props.option.email }}</span>
                    <span class="option__name" v-else><i class="material-icons">perm_identity</i>{{ props.option.email }}</span>

                    <span class="option__type">
                        <template v-if="props.client"><i class="material-icons">business</i> Company: {{ props.option.client.companyName }}</template>
                    </span>
                </template>

                <span slot="caret" v-if="ccContacts.length === 0"></span>
            </multiselect>
        </div>

        <div class="input-wrapper">
            <label>BCC:</label>
            <multiselect
                :toBeCopied="true"

                v-model         = "newEmail.bccAddresses"
                v-bind:options  = "bccContacts"
                v-bind:multiple = "true"
                v-bind:taggable = "true"
                v-bind:loading  = "isLoading.bccContacts"
                v-bind:internal-search = "false"
                label           = "email"
                track-by        = "email"
                placeholder     = ""
                v-on:tag        = "item => addContact(item, 'bcc')"
                v-on:open          = "getContacts('', 'bcc')"
                v-on:search-change = "search => getContacts(search, 'bcc')"
                v-on:close         = "tryContactPreselect('bcc')"
            >
                <template slot="option" slot-scope="props" v-if="props.option.firstName || props.option.email || props.option.lastName" >
                    <span class="option__name" v-if="props.option.firstName" ><i class="material-icons">perm_identity</i> {{ props.option.firstName + ' ' + props.option.lastName + " - " + props.option.email }}</span>
                    <span class="option__name" v-else><i class="material-icons">perm_identity</i>{{ props.option.email }}</span>

                    <span class="option__type">
                        <template v-if="props.client"><i class="material-icons">business</i> Company: {{ props.option.client.companyName }}</template>
                    </span>
                </template>

                <span slot="caret" v-if="bccContacts.length === 0"></span>
            </multiselect>
        </div>


        <div class="input-wrapper">
            <label>Vorlage:</label>
            <template-selection
                v-bind:preselected-request="preselectedRequest"
                v-bind:preselected-order="preselectedOrder"
            ></template-selection>
        </div>


        <div class="input-wrapper">
            <label>Betreff:</label>
            <input type="text" class="input" v-model="newEmail.subject" />
        </div>

        <div class="input-wrapper">
            <label>Beschreibung:</label>

            <tag-select
                v-model="tags"
                v-bind:option-tags="optionTags"
                my-class="is-medium"
            />
        </div>

        <div class="input-wrapper" v-if="((emailType === 'provider' && providerSelected && providerSelected.requests)) && requestOptions && requestOptions.statuses">
            <label>Status ändern:</label>
            <multiselect
                placeholder="nicht ändern"
                v-bind:options="requestOptions.statuses"
                label="value"
                track-by="key"
                v-model="status"
            />
        </div>

        <div class="input-wrapper">
            <label>Neue Aufgabe:</label>
            <input-date v-model="newEmail.todoDate"></input-date>
        </div>
        <div class="attachments">
            <label>Anhänge:</label>
            <attachments v-bind:ordersSelected="ordersSelected" v-model="newEmail._files"></attachments>
            <br>
        </div>

        <div class="pell-wrapper">
            <label>Text:</label>

            <div style="z-index:0">
                <loading v-if="isLoadingPreview"></loading>

                <div>
                    <div>
<!--                        <editor v-model="newEmail.textHtml" defaultParagraphSeparator="p style='Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:13px;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:16px;color:#6A6C6F;overflow-wrap:break-word'"/>-->
                        <email-editor v-model="newEmail.textHtml" @keyup="registerKeyUp" />
                    </div>
                </div>
            </div>
        </div>


        <div class="input-wrapper"></div>
        <div class="buttons-wrapper is-flex is-justify-content-right">
            <div class="is-flex">
                <button
                    class="button is-large"
                    v-on:click.prevent.stop="saveDraft"
                    v-bind:class="{ 'is-loading' : isLoading.draft }"
                    style="margin: 10px"
                >Outlook Entwurf erstellen</button>
                <div>
                    <button
                        class="button is-primary is-large mr-0"
                        v-bind:class="{ 'is-loading' : isLoading.send }"
                        v-on:click="send('close')"
                        style="margin: 10px"
                    ><i class="material-icons">check</i> Email senden</button>

                    <!--                <button
                                        class="button is-primary is-large"
                                        v-bind:class="{ 'is-loading' : isLoading.send }"
                                        v-on:click="send('close')"
                                    ><i class="material-icons">keyboard_arrow_right</i>Senden und Schließen</button>-->
                </div>

            </div>
        </div>
    </div>
</template>



<script>
import axios                from 'axios';
import jsonToFormData       from 'json-form-data';
import debounce             from 'lodash/debounce';
import uniq                 from 'lodash/uniq';
import uniqBy               from 'lodash/uniqBy';
import moment               from 'moment'
import {copy} from "@utilities/functions";

import Loading                        from '@components/Loading';
import { EmailEditor, Multiselect, InputDate }    from '@components/form';
import { defaultEmailTags } from '@clientSpecific/utilities/defaultValues'
import {settings} from "@clientSpecific/utilities/settings";
import { notifyError, notifySuccess } from '@components/Notification';
import { apiErrorMessage } from '@utilities/api';
import {getContacts, getUsers, optionsHotelRequests, editUser, getEmailTemplates} from '@api';
import { validateEmail, getValueWithKey, currentUser }              from '@utilities/functions';
import store          from '../../store';
import Attachments    from './Attachments';
import RequestsSelect from './RequestsSelect';
import TemplateSelection from './TemplateSelection';
import emailBody      from '@clientSpecific/email/template/EmailBody.js';
import TagSelect from "@components/form/TagSelect";
import EmailSelect from "@components/form/EmailSelect";

export default {
    store: store,
    props: {
        preselectedOrderConcept:   { default: null },//preSelects order
        preselectedConceptProvider: { default: null }, //preSelects provider and requests
        preselectedOrder:   { default: null },//preSelects order
        preselectedRequest: { default: null }, //preSelects provider and requests
        preselectedContact: { default: null }, //preSelects Contact
        selectTemplate :    { default: null }, //preSelects template
        attachDocument:     { type: Object, default: null}, //attaches a document
        showRequestSelect:  { type: Boolean, default: true},
        skipInit:           { type: Boolean, default: false} //true wenn das Form nur durch Modus-Wechsel neu erzeugt wurde
    },

    data: function () {
        return {
            settings: settings,
            formData: new FormData(),

            optionTags: defaultEmailTags,

            //contacts that will get updated each time the search string changes
            toContacts:         [],
            bccContacts:         [],
            ccContacts: [],

            tags: [],
            options: [],

            requestStatus: null,
            requestOptions: null,

            isLoading: {
                send:       false,
                preview:    false,
                toContacts: false,
                ccContacts: false,
                bccContacts: false,
                draft: false,
                recentContact: false
            },

            //latest sender of the selected provider/agency, from the stored emails
            recentContact: null
        }
    },

    computed: {
        showStore () {
            return this.$store
        },

        requestsSelected: function () {
            return this.$store.state.requestsSelected;
        },

        ordersSelected: function () {
            return this.$store.state.ordersSelected;
        },

        isLoadingPreview: function () {
            return !!this.$store.state.isLoadingPreview;
        },

        emailType: function () {
            return this.$store.state.emailType;
        },

        providerSelected: function () {
            return this.$store.state.providerSelected;
        },

        showRecentContact: function () {
            if (!this.recentContact || this.emailType !== 'provider' || this.$store.state.bulkMode || this.$store.state.isPhone) {
                return false;
            }
            const email = this.recentContact.email;
            return !(this.newEmail.toAddresses || []).some(address => address && (address.email || '').trim().toLowerCase() === email);
        },

        newEmail: {
            get: function() {
                return this.$store.state.newEmail;
            },
            set: function (value) {
                this.$store.state.newEmail = value;
            }
        },

        emailSelected: function () {
            return this.$store.getters.emailsSelected[0];
        },

        contactOptions: function () {
            return this.$store.state.contacts;
        },

        action:             function () { return this.$store.state.action; },

        status: {
            get() {
                return this.requestOptions.statuses.find(status => status.key === this.requestStatus)
            },
            set: function(status) {
                this.requestStatus = !!status ? status.key : null
            }
        },
    },

    methods: {
        loadRecentContact: function () {
            this.recentContact = null;
            const selected = this.providerSelected;
            if (!selected || !selected.provider || !selected.provider.id || this.emailType !== 'provider') {
                return;
            }
            const request = (selected.requests || [])[0];
            const params = {
                kind:  selected.isAgency ? 'agency' : 'provider',
                id:    selected.provider.id,
                order: request ? request.orderID : null
            };
            axios.get('/api/email_provider_contacts/recent', { params }).then(response => {
                // the selection may have changed while loading
                if (this.providerSelected === selected) {
                    this.recentContact = response.data.latest;
                }
            }, () => { /* only a hint — the form works without it */ });
        },

        takeRecentContact: function () {
            const recent = this.recentContact;
            const owner = this.providerSelected && this.providerSelected.provider;
            const known = recent.knownContact
                ? Promise.resolve(recent.contact)
                : axios.post('/api/email_provider_contacts', {
                    kind:  recent.owner.kind,
                    id:    recent.owner.id,
                    email: recent.email,
                    name:  recent.name
                }).then(response => {
                    if (response.data.created) {
                        notifySuccess('Kontakt ' + (response.data.contact.fullName || recent.email) + ' angelegt');
                    }
                    return response.data.contact;
                });

            this.isLoading.recentContact = true;
            known.then(contact => {
                const recipient = Object.assign({}, contact, { email: recent.email });
                if (owner && Array.isArray(owner.contacts) && !owner.contacts.some(item => item.id === contact.id)) {
                    owner.contacts.push(recipient);
                }
                if (Array.isArray(this.$store.state.contacts) && !this.$store.state.contacts.some(item => item.id === contact.id)) {
                    this.$store.state.contacts.push(recipient);
                }
                recent.knownContact = true;
                recent.contact = contact;
                this.newEmail.toAddresses = [recipient];
            }, error => {
                notifyError((error.response && error.response.data && error.response.data.error) || 'Der Kontakt konnte nicht angelegt werden');
            }).then(() => { this.isLoading.recentContact = false; });
        },

        copy,

        registerKeyUp () {
            this.$store.state.emailManuallyChanged = true;
        },

        getFullName: function (contact) {
            let name = contact.firstName || '';

            if (contact.lastName) {
                name += (name ? ' ' : '') + contact.lastName;
            }

            return name;
        },

        prepareForSending: function () {
            let copyNewEmail = JSON.parse(JSON.stringify(this.newEmail)),
                form = {},
                incorrectAddress = false,

                prepareContact = (contact) => {
                        if (!validateEmail(contact.email)) {
                            incorrectAddress = true;
                        }

                        return {
                            email: contact.email.trim(),
                            name:  this.getFullName(contact)
                        }
                    };

            copyNewEmail.toAddresses = copyNewEmail.toAddresses.map(prepareContact);
            copyNewEmail.bccAddresses = copyNewEmail.bccAddresses.map(prepareContact);
            copyNewEmail.ccAddresses = copyNewEmail.ccAddresses.map(prepareContact);


            if (incorrectAddress) {
                notifyError('Falsche email Adresse!');
                return false;
            }


            if (!copyNewEmail.subject) {
                notifyError('Der Betreff darf nicht leer sein!');
                return false;
            }
            copyNewEmail.subject = copyNewEmail.subject.replace("\n", '');


            if (!copyNewEmail.textHtml) {
                notifyError('Die Nachricht darf nicht leer sein!');
                return false;
            }

            if (this.preselectedOrderConcept) {

                copyNewEmail.links = [
                    {
                        orderConcept: '/api/order_concepts/' + this.preselectedOrderConcept.id
                    }
                ]
            } else {
                // Order links always follow the "Vorgänge" selection (orders removed there must not be linked);
                // non-order links of a replied/forwarded email (e.g. orderConcept) are kept
                const nonOrderLinks = (copyNewEmail.links || [])
                    .filter(link => !link.order && link.orderConcept)
                    .map(link => ({
                        orderConcept: link.orderConcept.id ? '/api/order_concepts/' + link.orderConcept.id : link.orderConcept
                    }));

                copyNewEmail.links = [
                    ...uniq(this.ordersSelected.map(order => order.id)).map(id => ({ order: '/api/orders/' + id })),
                    ...nonOrderLinks,
                ];
            }



            copyNewEmail['_files']               = this.newEmail._files.filter(item => !item.id);
            copyNewEmail['_attachedDocumentIds'] = this.newEmail._files
                                                        .filter(item => item.id && !item.disposition)
                                                        .map(item => item.id);
            copyNewEmail['_attachmentsForwarded'] = this.newEmail._files.filter(item => item.disposition);

            if (this.requestStatus) {
                copyNewEmail['requestStatus'] = this.requestStatus;
                copyNewEmail['requests'] = this.requestsSelected.map(({ id }) => `/api/requests/${id}`);
            }
            if (this.$store.state.conceptProvidersSelected.length > 0) {
                copyNewEmail['priceRequestYear'] = this.$store.state.priceRequestYear;
                copyNewEmail['conceptProviders'] = this.$store.state.conceptProvidersSelected.map(({ id }) => `/api/concept_providers/${id}`);
            }

            copyNewEmail['tags'] = this.tags.map(({name}) => name);

            this.formData = jsonToFormData(copyNewEmail);


            return true;
        },

        send: function (close) {
            if (this.prepareForSending()) {
                // Check if changing to 'canceled' status without storno tag
                const stornoCheckTag = settings.request?.stornoCheckTag;
                if (stornoCheckTag && this.requestStatus === 'canceled') {
                    const hasStornoTag = this.tags.some(tag =>
                        tag.name && tag.name.toLowerCase().includes(stornoCheckTag.toLowerCase())
                    );
                    if (!hasStornoTag) {
                        if (!confirm('Keine Storno-Tag gefunden. Bist du sicher, dass du den Status ändern möchtest?')) {
                            return;
                        }
                    }
                }

                this.isLoading.send = true;

                axios.post('/api/emails/send', this.formData, { skipErrorToast: true })
                    .then(response => {
                        notifySuccess('Email gesendet!');
                        if (close === 'close') { this.$emit('close'); }
                        this.formData = new FormData();
                        const requestsChanged = !!this.requestStatus && this.requestsSelected.length > 0;
                        this.$emit('closeModal', requestsChanged);
                    }, error => { notifyError('E-Mail wurde nicht gesendet: ' + apiErrorMessage(error)); })
                    .then(() => {
                        // Always executed (success or error)
                        this.isLoading.send = false;
                    });
            }
        },

        addContact: function (contact, type = 'to') {
            type = type + 'Addresses';
            this.newEmail[type].push({ email: contact });
        },

        tryContactPreselect: function (type = 'to') {
            type = type + 'ContactPreselect';
            let addressType = type + 'Addresses';
            // When losing focus add the email written (even without and enter/select)
            if (this[type]) {
                this.newEmail[addressType].push({ email: this[type] });
            }
        },

        searchContacts: function (search, contactsType) {
            search = search.toLowerCase();
            this[contactsType] = [];
            let contacts = this.contactOptions;

            this[contactsType] = contacts.filter(c =>
                c.email && (
                ((c.lastName || c.firstName) && (c.firstName + ' ' + c.lastName).toLowerCase().indexOf(search) !== -1) ||
                (c.email.toLowerCase().indexOf(search) !== -1))
            ).sort((a, b) => {
                if(a.username && !b.username) {
                    return 1;
                }
                if(b.username && !a.username) {
                    return -1;
                }
                if ((a.firstName && b.firstName) ) {
                    if ((a.firstName + ' ' + a.lastName) > (b.firstName + ' ' + b.lastName)) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                } else {
                    if ((a.email) > (b.email)) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
            });
        },

        getContacts: function (search = '', type = 'to') {
            this.searchContacts(search, type + 'Contacts');
        },

        doReplyOrForward: function () {
            const selectedEmail = JSON.parse(JSON.stringify(this.emailSelected));


            // It is an action (reply, replyAll or forward)
            this.newEmail.subject = (this.action === 'forward' ? 'FW: ' : 'RE: ') + selectedEmail.subject;
            this.newEmail.toAddresses = [{
                email:     selectedEmail.fromAddress,
                firstName: selectedEmail.fromName,
                lastName:  null,
                ...selectedEmail.contact && selectedEmail.contact.emailInfos && selectedEmail.contact.emailInfos[3] && {
                    id: selectedEmail.contact.emailInfos[3]
                }
            }];
            this.newEmail.links       = selectedEmail.links;

            let textPhone = '';
            if(this.userPhoneDirect){
                textPhone = '(Dw. ' + this.userPhoneDirect + ')';
            }
            if(this.action === 'forward') {
                this.newEmail._files = selectedEmail.attachments.filter(item => item.disposition === 'attachment').map(item => ({
                    ...item,
                    name: item.fileName,
                }));
            }

            this.newEmail.textHtml    = emailBody(this.organisation, '', textPhone, selectedEmail);
        },

        saveDraft: function() {
            if (this.prepareForSending()) {
                this.isLoading.draft = true;

                axios.post('/api/emails/draft/save', this.formData)
                    .then(response => {
                        notifySuccess('Enwurf wurde erfolgreich im Outlook Entwürfe Ordner gespeichert');
                    }, error => { notifyError('Der Entwurf konnte nicht erstellt werden! Server Error!'); })
                    .then(() => {
                        // Always executed (success or error)
                        this.isLoading.draft = false;
                        this.formData = new FormData();
                    });
            }
        },


        getValueWithKey
    },


    created: function () {
        if (this.skipInit) {
            //Form wurde nur durch den Massenemail-Toggle neu erzeugt — Store ist bereits initialisiert
            return;
        }

        this.$store.state.isOpen = true;
        this.$store.state.isPhone = false;
        //Sicherheitsnetz für Flows ohne index.vue (z.B. ConceptEmail): Massenemail-Modus deaktivieren
        this.$store.state.bulkMode = false;

        this.$layout.toggleRightSideBar('AiChat')

        //Handle preselectedOrders and Requests

        if(this.preselectedOrderConcept) {
            let preselectedOrderConcept = this.preselectedOrderConcept;
            let preselectedConceptProvider = this.preselectedConceptProvider;
            this.$store.dispatch('preselectOrderConcepts', {preselectedOrderConcept, preselectedConceptProvider}).then(response => {
                this.$store.dispatch('resetEmailForm', {templateToSelect: this.selectTemplate, contactToSelect: this.preselectedContact, documentToAttach: this.attachDocument});
            });
        } else {
            let preselectedOrder = this.preselectedOrder;
            let preselectedRequest = this.preselectedRequest;
            console.log('created', preselectedOrder, preselectedRequest)
            this.$store.dispatch('preselectOrders', {preselectedOrder, preselectedRequest}).then(response => {
                console.log('resetEmailForm')
                this.$store.dispatch('resetEmailForm', {templateToSelect: this.selectTemplate, contactToSelect: this.preselectedContact, documentToAttach: this.attachDocument});
            });
        }

    },


    watch: {
        providerSelected: {
            handler: 'loadRecentContact',
            immediate: true
        },

        emailType: {
            handler: function () {
                if (!this.requestOptions) {
                    optionsHotelRequests().then(response => {
                        this.requestOptions = response.data;

                    }, error => { notifyError('Couldn\'t load the Request Options'); });
                }
            },
            immediate: true
        },

        'newEmail.toAddresses': function () {
            if (this.newEmail.toAddresses) {
                this.$store.dispatch('fillEmailBody');
                const unique = uniqBy(this.newEmail.toAddresses, item => item.email);
                if (unique.length < this.newEmail.toAddresses.length) {
                    this.newEmail.toAddresses = unique;
                }
            }
        },


        'newEmail.bccAddresses': function () {
            if (this.newEmail.bccAddresses) {
                const unique = uniqBy(this.newEmail.bccAddresses, item => item.email);

                if (unique.length < this.newEmail.bccAddresses.length) {
                    this.newEmail.bccAddresses = unique;
                }
            }
        },

        'newEmail.ccAddresses': function () {
            if (this.newEmail.ccAddresses) {
                const unique = uniqBy(this.newEmail.ccAddresses, item => item.email);

                if (unique.length < this.newEmail.ccAddresses.length) {
                    this.newEmail.ccAddresses = unique;
                }
            }
        },

        '$store.state.variantSelected': function(variant) {
            this.tags = variant ?
                variant.tags.map(tag => {
                    return {
                        name: tag
                    }
                }) : []
        },
    },


    components: {
        InputDate,
        EmailSelect,
        TemplateSelection,
        TagSelect,
        Attachments,
        EmailEditor,
        Loading,
        Multiselect,
        RequestsSelect,
    }
}

</script>
